import _ from 'common-tools/LodashHelper'
import { sh } from './statehelpers'
import { ah } from './actionhelpers'

export const pt = require('prop-types')

export const buildPropTypes = (props, init) => {
  let propTypes = {}

  _.forEach(props, (p) => {
    let testP = _.isFunction(p) ? p.name || '' : p

    // does this match action helpers

    if (_.has(ah, testP)) {
      if (testP === ah.formatHelper) {
        propTypes[testP] = pt.shape({
          formatDate: pt.func.isRequired
        }).isRequired
        return
      }

      propTypes[testP] = pt.func.isRequired
      return
    }

    // must be a string or text
    switch (testP) {
      // func required
      case sh.translate:
        propTypes[testP] = pt.func.isRequired
        break
      case sh.SessionToken:
        propTypes[testP] = pt.string
        break
      case sh.currentPath:
        propTypes[testP] = pt.string.isRequired
        break
      // custom
      case sh.SessionAccount:
        propTypes[testP] = pt.shape({
          EmailAddress: pt.string,
          FirstName: pt.string,
          LastName: pt.string
        }).isRequired
        break
      case sh.SessionConfig:
        propTypes[testP] = pt.shape({
          Url: pt.string
        })
        break
      case sh.DrawerEvents:
        propTypes[testP] = pt.object.isRequired
        break
      case 'AppState':
        propTypes['AppStateKey'] = pt.string.isRequired
        break
      case 'DeleteItems':
        propTypes['items'] = pt.arrayOf(pt.shape({
          _key: pt.string,
          Text: pt.string
        }))
        break
      case 'SaveItems':
        propTypes['items'] = pt.arrayOf(pt.shape({
          _key: pt.string,
          Text: pt.string,
          DBSelected: pt.bool,
          Selected: pt.bool
        }))
        break
    }
  })

  if (init) {
    return _.merge({}, init, propTypes)
  } else {
    return propTypes
  }
}

// Stub export for legacy views that import ptList
export const ptList = pt.arrayOf(pt.any)
